import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: "fullname"
})
export class FullNamePipe implements PipeTransform {

  transform(value: any, index: number): string {
    if (value) {
      const fullname = value.split(",");
      if (index === 1) {
        return fullname[index].trim().split(" ")[0]
      }
      return fullname[index];
    } else {
      return "N/A";
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/fullname.pipe.ts